import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { defaultTableTypes } from '../../constants/tableTypes';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'hospitality-bot-table-switch',
  templateUrl: './table-switch.component.html',
  styleUrls: ['./table-switch.component.scss'],
})
export class TableSwitchComponent implements OnInit {
  @Input() tableGroup: 'campaign' | 'reservation' | 'outlet';
  @Input() isPmsSubscribed: boolean = true;

  selectedTableTypes: TableType[] = [];
  tableFG: FormGroup;

  @Output() onChange = new EventEmitter();

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit(): void {
    this.selectedTableTypes = defaultTableTypes[this.tableGroup];
    if (this.tableGroup === 'outlet' && !this.isPmsSubscribed) {
      this.selectedTableTypes = this.selectedTableTypes.filter(
        (option) => option.value !== 'inRoom'
      );
    }
    this.initControl();
  }

  initControl() {
    this.tableFG = this.controlContainer.control as FormGroup;
    this.tableFG.addControl('tableType', new FormControl(''));
    const defaultType = this.selectedTableTypes.find(type => type.value === 'card') 
      || this.selectedTableTypes[1] 
      || this.selectedTableTypes[0];
    this.setTableType(defaultType.value);
  }

  setTableType(value: string) {
    this.tableFG.patchValue({ tableType: value });
    this.onChange.emit(value);
  }
}

type TableTypeGroup = 'reservation' | 'campaign' | 'outlet';

// Define type for the table type object
type TableType = {
  name: string;
  value: string;
  url: string;
  whiteUrl: string;
  backgroundColor: string;
};

// Define type for the defaultTableTypes constant
export type DefaultTableTypes = {
  [Key in TableTypeGroup]: TableType[];
};
